
import img1 from './Cart/black-toothpaste.jpg';
import img2 from './Cart/electrical_toothbrush.jpg';
import img3 from './Cart/mouth_fresher.jpg';
import img4 from './Cart/Oral_spray.jpg';
import img5 from './Cart/toothbrush.jpg';



const Datacart = {
    ProductDetail:[
        {
            id:1,
            img:img1,
            title:"Tooth Paste",
            desc:'',
            price: 20,
        },
        {
            id:2,
            img:img2,
            title:"Electrical ToothBrush",
            desc:'',
            price: 50,
        },
        {
            id:3,
            img:img3,
            title:"Mouth Fresher",
            desc:'',
            price: 40,
        },
        {
            id:4,
            img:img4,
            title:"Oral Spray",
            desc:'',
            price: 30,
        },
        {
            id:5,
            img:img5,
            title:"Tooth Brush",
            desc:'',
            price: 20,
        }
    ]
}

export default Datacart;